export const data = () => {
    return {
        file: null,
        disable_incorporation: 1,
        only_validation: 1,
        document_date:null,
    }
}

export default {
    preloader: false,
    data: data()
}



// WEBPACK FOOTER //
// ./src/modules/incorporate_accounting_movements/state.js